import { render, staticRenderFns } from "./TestCandidateHistory.vue?vue&type=template&id=20aa9fb3"
import script from "./TestCandidateHistory.vue?vue&type=script&lang=js"
export * from "./TestCandidateHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports